import { useContext } from 'react'
import loginContext, { LoginContextProps } from '../contexts/loginContext/loginContext'

const useLogin = () => {
    return useContext(loginContext) as LoginContextProps
}

export default useLogin